import api from '../../services/api'

export default {
  state: {
    accessRequests: []
  },
  getters: {
    accessRequests (state) {
      return state.accessRequests
    }
  },
  mutations: {
    setAccessRequests (state, accessRequests) {
      state.accessRequests = accessRequests
    },
    createAccessRequest (state, accessRequest) {
      state.accessRequests.push(accessRequest)
    },
    removeAccessRequest (state, requesterUserId) {
      state.accessRequests = state.accessRequests.filter(
        accessRequest => accessRequest.requester_user.id !== requesterUserId
      )
    },
    removeAccessRequestByProductToken (state, productToken) {
      state.accessRequests = state.accessRequests.filter(
        accessRequest => accessRequest.product_token !== productToken
      )
    },
    clearAccessRequests (state) {
      state.accessRequests = []
    }
  },
  actions: {
    fetchAccessRequests ({ commit }) {
      commit('clearError')
      commit('setLoading', true)

      return new Promise((resolve, reject) => {
        api.get('accessrequests/')
          .then(result => {
            commit('clearAccessRequests')
            commit('setAccessRequests', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('clearAccessRequests')
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
          .finally(() => commit('setLoading', false))
      })
    },
    createAccessRequest ({ commit }, accessRequest) {
      commit('clearError')
      commit('setLoading', true)

      const newAccessRequest = {
        product_description: accessRequest.product_description,
        product_token: accessRequest.product_token,
        product_model: accessRequest.product_model,
        requester_role: accessRequest.requester_role,
        requester_city_id: accessRequest.requester_city_id,
        isBrasil: accessRequest.isBrasil
      }
      return new Promise((resolve, reject) => {
        api.post('accessrequests/', newAccessRequest)
          .then(result => {
            // Do not commit it
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              // Be careful with that
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
          .finally(() => commit('setLoading', false))
      })
    },
    removeAccessRequest ({ commit }, accessRequest) {
      commit('clearError')
      commit('setLoading', true)

      return new Promise((resolve, reject) => {
        api.delete('accessrequests/', {
          data: {
            requester_user_id: accessRequest.requester_user_id,
            product_token: accessRequest.product_token
          }
        })
          .then(result => {
            commit('removeAccessRequest', accessRequest.requester_user_id)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
          .finally(() => commit('setLoading', false))
      })
    },
    removeAccessRequestByProductToken ({ commit }, productToken) {
      commit('removeAccessRequestByProductToken', productToken)
    },
    clearAccessRequests ({ commit }) {
      commit('clearAccessRequests')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accessRequest/index.js